import React from 'react';

export const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 py-12 px-8 text-center">
          <h1 className="text-4xl font-extrabold text-white mb-4 tracking-tight">
            Terms & Conditions
          </h1>
          <p className="text-blue-50 text-lg opacity-90">
            Please read these terms carefully before using our services.
          </p>
        </div>

        {/* Content Section */}
        <div className="p-8 md:p-12 text-slate-700 leading-relaxed space-y-8">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">01</span>
              Warranty & Maintenance
            </h2>
            <div className="space-y-4">
              <p>
                <strong className="text-slate-900">Warranty:</strong> The company warrants the kit from the delivery date as per specified terms.
              </p>
              <p>
                <strong className="text-slate-900">Maintenance:</strong> The customer is responsible for ensuring regular maintenance of the kit in accordance with the company's guidelines. Failure to perform such maintenance will result in the warranty becoming void.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">02</span>
              Battery & Charging
            </h2>
            <div className="space-y-4">
              <p>
                If the battery is installed by us, it is warranted for 3 years. For any claims, the customer shall directly approach the manufacturer, who is solely responsible for addressing such claims.
              </p>
              <p>
                <strong className="text-slate-900">Important:</strong> Only use the provided charger to avoid damage and maintain battery health.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">03</span>
              Safety & Registration
            </h2>
            <p>
              Always wear a helmet and follow traffic rules for your safety. It is the customer's duty to register and insure the bike at the time of delivery.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">04</span>
              Returns & Refunds
            </h2>
            <p>
              Registration fees are subject to forfeiture if installation isn't completed within the specified period. Failure to install within the designated timeframe may also render the customer ineligible for special pricing offers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">05</span>
              Intellectual Property
            </h2>
            <p>
              All content, trademarks, and intellectual property belong to KGV. No material from this website may be copied, reproduced, or distributed without explicit written consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">06</span>
              Legal & Disputes
            </h2>
            <p>
              These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Delhi. The company reserves the right to modify these terms or update software without prior notice.
            </p>
          </section>

          <div className="pt-8 border-t border-slate-100">
            <p className="text-sm text-slate-500 italic">
              * Force Majeure: The Company shall not be liable for any failure or delay in performing its obligations if caused by events beyond its reasonable control, including natural disasters, epidemics, or government actions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
